import type { Home } from '@efdigital/ll-addon-data';
import { DataTypeSystem } from '@efdigital/ll-addon-data/data-types';
import { query } from '@warp-drive/utilities/json-api';

import { jsonApiOptions } from '../../../lib/json-api.ts';

export function queryHome(clientId: string) {
  return query<Home>(
    DataTypeSystem.Home,
    {
      'filter[client.id]': clientId,
    },
    jsonApiOptions
  );
}
